import React from 'react';

const CancellationPolicy: React.FC = () => {
  return (
    // 'w-full' aur 'px-0' use kiya hai taaki corners se space na bache
    <div className="min-h-screen bg-gray-50 w-full py-6 px-4 md:px-12 font-sans">
      
      {/* Header Section - Full Width */}
      <div className="w-full mb-8 border-b pb-4">
        <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight">Cancellation Policy</h1>
        <nav className="text-sm font-medium text-gray-500 mt-2 uppercase tracking-widest">
          <span>Home</span> <span className="mx-2">/</span> <span className="text-blue-600">Cancellation Policy</span>
        </nav>
      </div>

      {/* Main Content Card - 'w-full' se poora spread hoga */}
      <div className="w-full bg-white shadow-sm border border-gray-200 rounded-xl p-6 md:p-16 text-gray-700">
        
        {/* Section: Introduction */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 border-l-4 border-blue-600 pl-4">Introduction</h2>
          <p className="text-lg leading-relaxed max-w-none">
            Humari company samajhti hai ki kabhi-kabhi clients ko services terminate karne ki zaroorat pad sakti hai. 
            Is process ko fair aur transparent banane ke liye, humne yeh cancellation policy design ki hai. 
            Yeh policy aapke aur company ke beech ke agreement ka ek mahatvapurna hissa hai.
          </p>
        </section>

        {/* Section: Eligibility */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 border-l-4 border-blue-600 pl-4">Eligibility for Cancellation</h2>
          <p className="text-lg leading-relaxed">
            Client apni membership ya service ko agreement sign karne ke **21 dino** ke bheetar cancel karne ke liye eligible hain. 
            Is nirdharit samay (window) ke baad kiye gaye kisi bhi anurodh par koi refund process nahi kiya jayega.
          </p>
        </section>

        {/* Section: Procedure */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 border-l-4 border-blue-600 pl-4">Cancellation Procedure</h2>
          <div className="bg-gray-50 p-8 rounded-lg border border-gray-100">
            <p className="mb-4 font-semibold text-gray-800 italic underline">Cancellation request niche diye gaye documents ke sath written mein honi chahiye:</p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 ml-4">
              <li className="flex items-center space-x-2">
                <span className="h-2 w-2 bg-blue-600 rounded-full"></span>
                <span>Full Name aur Client ID</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="h-2 w-2 bg-blue-600 rounded-full"></span>
                <span>Date of Agreement</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="h-2 w-2 bg-blue-600 rounded-full"></span>
                <span>Reason for Cancellation</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="h-2 w-2 bg-blue-600 rounded-full"></span>
                <span>Payment Confirmation Details</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="h-2 w-2 bg-blue-600 rounded-full"></span>
                <span>Signed Copy of Agreement</span>
              </li>
            </ul>
          </div>
        </section>

        {/* Section: Forfeiture */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 border-l-4 border-blue-600 pl-4">Forfeiture and Termination</h2>
          <div className="space-y-6">
            <div className="p-4 bg-red-50 border-r-4 border-red-500 rounded">
              <p className="font-medium text-red-800">
                Agar membership fees ya dues notify hone ke 7 dino mein pay nahi hote, toh agreement turant terminate mana jayega aur purani payments lautai nahi jayengi.
              </p>
            </div>
            <div className="p-4 bg-orange-50 border-r-4 border-orange-500 rounded">
              <p className="font-medium text-orange-800">
                Installment plans mein lagatar 2 payments fail hone par agreement bina notice ke rescind (radd) kar diya jayega.
              </p>
            </div>
          </div>
        </section>

        {/* Section: Irrevocability */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-red-700 mb-6 border-l-4 border-red-700 pl-4">Irrevocability</h2>
          <p className="text-lg leading-relaxed">
            Ek baar cancellation approve hone ke baad use wapas nahi liya ja sakta. Client ki membership aur service access 
            humesha ke liye band kar di jayegi. Dobara judne ke liye naya agreement aur nayi process follow karni hogi.
          </p>
        </section>

        {/* Footer Note */}
        <div className="mt-16 pt-8 border-t border-gray-100 text-center">
          <p className="text-gray-400 text-sm">
            This Cancellation Policy forms an integral part of the Purchase and Service Agreements, binding upon all parties from the date of signature.
          </p>
        </div>

      </div>
    </div>
  );
};

export default CancellationPolicy;